import React, { useState } from 'react';
import { Header } from '../components/Header';
import { VideoPlayer } from '../components/VideoPlayer';
import { StatsSection } from '../components/StatsSection';
import { HeroHighlight, Highlight } from '../components/ui/HeroHighlight';
import { CalendlyEmbed } from '../components/CalendlyEmbed';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
export function HomePage() {
  const [videoProgress, setVideoProgress] = useState(0);
  // Handler for video progress updates (keeping this for analytics purposes)
  const handleVideoProgress = (percent: number) => {
    setVideoProgress(percent);
  };
  return <div className="w-full min-h-screen" data-id="element-96">
      <HeroHighlight data-id="element-97">
        <Header data-id="element-98" />
        <main className="max-w-6xl mx-auto px-4" data-id="element-99">
          <div id="headline" data-id="element-100">
            <p className="text-center text-sm sm:text-lg mb-2 mt-4 text-white" data-id="element-101">
              For Ambitious Self-Starters Ready to Break Into Sales…
            </p>
            <h1 className="text-center text-2xl sm:text-4xl md:text-5xl font-bold mb-6 sm:mb-8 max-w-4xl mx-auto leading-[1.4] sm:leading-[1.3] text-white" data-id="element-102">
              Join <Highlight className="px-1" data-id="element-103">SVRN PRO's</Highlight>{' '}
              High-Performance Team &amp; Earn{' '}
              <Highlight className="px-1" data-id="element-104">$55K–$80K+</Highlight> in{' '}
              <Highlight className="px-1" data-id="element-105">Year One</Highlight>
            </h1>
            <div className="mb-10 sm:mb-12" data-id="element-106">
              <p className="text-center text-base sm:text-xl mb-4 sm:mb-6 text-white" data-id="element-107">
                <strong data-id="element-108">Step 1: Tap play</strong> to see how the role works and
                how we win together
              </p>
              <VideoPlayer onWatchProgress={handleVideoProgress} data-id="element-109" />
            </div>
          </div>
          <div id="calendly" className="text-center mb-6" data-id="element-110">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-black mb-2 text-white" data-id="element-111">
              Step 2: Fill out the short application to{' '}
              <Highlight data-id="element-112">apply now</Highlight>
            </h2>
            <p className="text-base sm:text-xl text-white/70 mb-2" data-id="element-113">
              Please complete watching the video above before submitting your
              application.
            </p>
          </div>
          <CalendlyEmbed data-id="element-114" />
          <StatsSection data-id="element-115" />
          <div id="faq" data-id="element-116">
            <FAQSection data-id="element-117" />
          </div>
          <Footer data-id="element-118" />
        </main>
      </HeroHighlight>
    </div>;
}